import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchGrammarTopics } from "./grammarService";
import "./GrammarTopicListPage.css";

const GrammarTopicListPage = () => {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();

  const load = useCallback(async () => {
    console.log("[GrammarTopicListPage] Loading topics, page:", page, "search:", search);
    setLoading(true);
    const res = await fetchGrammarTopics({ page, size: 20, search: search || undefined });
    if (res.status === 200 && res.data?.status) {
      console.log("[GrammarTopicListPage] Loaded", res.data.data?.length || 0, "topics");
      setTopics(res.data.data || []);
      setTotalPages(res.data.totalPages || 0);
      setTotalItems(res.data.totalItems || 0);
    } else {
      console.error("[GrammarTopicListPage] Load failed:", res.status, res.message);
      setTopics([]);
      setTotalPages(0);
      setTotalItems(0);
    }
    setLoading(false);
  }, [page, search]);

  useEffect(() => { load(); }, [load]);

  return (
    <>
      <Navbar />
      <div className="grammar-page">
        <h1 className="grammar-title">✏️ Grammar</h1>
        <p className="grammar-subtitle">Master English grammar with structured topics and clear explanations.</p>

        <div className="grammar-filters">
          <input
            className="grammar-search"
            type="text"
            placeholder="Search grammar topics..."
            value={search}
            onChange={(e) => { setPage(0); setSearch(e.target.value); }}
          />
        </div>

        {totalItems > 0 && (
          <p className="grammar-count">{totalItems} topics found</p>
        )}

        {loading ? (
          <p className="grammar-loading">Loading...</p>
        ) : topics.length === 0 ? (
          <p className="grammar-empty">No grammar topics available yet.</p>
        ) : (
          <div className="grammar-grid">
            {topics.map((t) => (
              <div key={t.id} className="grammar-card" onClick={() => navigate(`/study/grammar/${t.id}`)}>
                <span className="grammar-card-icon">{t.icon || "📘"}</span>
                <h3 className="grammar-card-title">{t.title}</h3>
                <p className="grammar-card-desc">{t.description}</p>
                <span className="grammar-card-count">{t.subTopicCount || 0} sub-topics</span>
              </div>
            ))}
          </div>
        )}

        {totalPages > 1 && (
          <div className="grammar-pagination">
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>← Prev</button>
            <span>Page {page + 1} / {totalPages}</span>
            <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next →</button>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default GrammarTopicListPage;
